import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Is this religious or does it conflict with my beliefs?',
  a: 'The Lucky Flush Protocol is non-denominational. It combines sound therapy (a clinically studied modality) with mindset scripting. Women of all faith backgrounds have used and benefited from this protocol.'
}, {
  q: 'How quickly will I notice a difference?',
  a: "Most women report a noticeable shift in how they feel by Day 3. External 'luck' events tend to be noticed between Day 5 and Day 14 after completing the protocol."
}, {
  q: 'Do I need any special equipment?',
  a: 'No. You need a phone or computer to play the audio, a printer (optional) for the PDF pages, and sea salt for Day 1 (standard table salt also works).'
}, {
  q: "What if I'm skeptical and don't really believe in this?",
  a: 'Perfect. The protocol was designed with skeptics in mind. The science section explains the neurological and bioelectric basis for why this works — no prior spiritual belief required.'
}, {
  q: 'What happens after I purchase?',
  a: 'You receive immediate access to all digital files via a download page. Everything is delivered instantly — no waiting, no shipping.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-24 px-4 bg-navy bg-grain" data-id="element-29">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-30">
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-6 font-medium text-center" data-id="element-31">
          COMMON QUESTIONS
        </p>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream text-center mb-16" data-id="element-32">
          Answers Before You Decide
        </h2>

        <div className="w-full space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <div key={index} className="border border-gold/20 rounded-xl bg-navy-dark overflow-hidden transition-colors duration-300 hover:border-gold/40" data-id="element-34">
              <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-35">
                <span className="font-serif text-xl text-cream pr-4" data-id="element-36">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
              </button>

              <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-38">
                <div className="p-6 pt-0 text-cream/70 leading-relaxed" data-id="element-39">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}